import { Tabs } from "@jana-technology/platform-ui";

import { useNavTabsFromHandle } from "hooks/useNavTabsFromHandle";

export const SystemOverviewNavTabs = () => {
  const { primaryTabs, secondaryTabs, primaryDefaultTab, secondaryDefaultTab } =
    useNavTabsFromHandle();

  return primaryTabs ? (
    <div className="flex justify-between">
      <Tabs
        asNav
        items={primaryTabs}
        value={primaryDefaultTab}
        className="uppercase"
      />
      {secondaryTabs && (
        <Tabs
          asNav
          kind="secondary"
          items={secondaryTabs}
          value={secondaryDefaultTab}
        />
      )}
    </div>
  ) : null;
};

export default SystemOverviewNavTabs;
